import { render } from "./exclamationIcon.svg?vue&type=template&id=f548855a"
const script = {}
script.render = render

export default script